module.exports = __webpack_public_path__ + "img/checkApps_tablet.7b831516.svg";